module.exports = __webpack_public_path__ + "img/di_16_Debt.47b4bc1b.png";